import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { Button } from "../../../components/ui/button"
import { X, Check } from "lucide-react"
import { FormField } from "./form-field"
import { ClipLoader } from "react-spinners"

import { useThemeStore } from "../../../context/useThemeStore"

export function FormBuilderModal({
  isOpen,
  onClose,
  templateId,
  promptId,
  title = "Form",
  description,
  onSubmit,
  submitButtonLabel = "Submit",
  students,
  selectedPromptTemplate
}) {
  const { theme } = useThemeStore();
  const [formFields, setFormFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  // const [theme, setTheme] = useState(
  //   localStorage.getItem("SA_user_theme") || "light",
  // );

//   useEffect(() => {
//   const listener = () => {
//     setTheme(localStorage.getItem("SA_user_theme") || "light")
//   }

//   window.addEventListener("storage", listener)
//   return () => window.removeEventListener("storage", listener)
// }, [])

  useEffect(() => {
    if (!templateId || !selectedPromptTemplate) return;

    const loadTemplate = async () => {
      setIsLoading(true);
      try {
        const apiFields = selectedPromptTemplate?.system_props?.viz_props;

        // Set dynamic fields
        setFormFields(apiFields);

        // Build initial form values
        const initial = {};
        apiFields?.forEach((field) => {
          initial[field.name] =
            field.defaultValue ??
            (field.inputType === "multiselect" ? [] : "");
        });

        setFormData(initial);
      } catch (error) {
        console.error("Error loading template:", error);
      }finally {
        setIsLoading(false);
      }
    };

    loadTemplate();
  }, [selectedPromptTemplate,templateId]);

  const validateForm = () => {
    const newErrors = {}
    formFields.forEach((field) => {
      if (field.required) {
        const value = formData[field.name]

        if((formData["information_source"]=="Gemini only" && field.inputType === "file-uploader")){
          return
        }else if (field.inputType === "multiselect" || field.inputType === "student-list") {
          if (!Array.isArray(value) || value.length === 0) {
            newErrors[field.name] = `${field.label} is required`
          }
        } else if (!value) {
          newErrors[field.name] = `${field.label} is required`
        }
      }
    })
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleFieldChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }))
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[name]
        return newErrors
      })
    }
  }

  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit(formData, null, promptId,selectedPromptTemplate?.system_props?.chat_visible_to_members,selectedPromptTemplate?.type);
      onClose()
    }
  }

  const modalClasses =
    theme === "dark"
      ? "dark bg-[#121928] text-gray-100 addEditModal max-h-[90vh] border border-border"
      : "bg-gray-50 text-gray-900 addEditModal max-h-[90vh] border border-border";

  const modalHeaderClasses =
    theme === "dark" ? "dark bg-[#1f2937]" : "bg-white";
  

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      centered
      // scrollable
      // // contentClassName={modalClasses}
      data-bs-theme={theme === "dark" ? "dark" : "light"}
      //contentClassName="bg-card border border-border max-h-[90vh]"
      // contentClassName={`
      //   max-h-[90vh] border border-border
      //   bg-white text-black
      //   dark:bg-card dark:text-foreground
      // `}
    >
      {/* Header */}
      <Modal.Header closeButton className={`${modalHeaderClasses} border-b border-border bg-card sticky top-0 z-10`}>
        <Modal.Title>
          <h2 className="text-2xl font-bold text-foreground">{title}</h2>
          {description && (
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body className="px-6 py-6 space-y-6">
        {isLoading ? (
          <div className="flex flex-col items-center justify-center py-16 gap-4">
                <ClipLoader size={40} color="var(--primary-icon)" />
          </div>
        ) : (
        <div className="space-y-6">
        {formFields?.map((field) => (
          <FormField
            key={field.name}
            field={field}
            value={formData[field.name]}
            formData={formData}
            students={students}
            onChange={(value) => handleFieldChange(field.name, value)}
            onChangeWithKey={(key,value) => handleFieldChange(key, value)}
            error={errors[field.name]}
          />
        ))}
      </div>
        )}
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer className={`${modalHeaderClasses} border-t border-border sticky bottom-0 bg-card flex justify-end gap-3`}>
        <Button
          onClick={onClose}
          variant="outline"
          className="text-foreground border-border hover:bg-muted bg-transparent"
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          className="action-btn primary flex items-center gap-2"
        >
          <Check className="w-4 h-4" />
          {submitButtonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
